import '../../index.css';
var styles = {
  "noticeWrapper": "bp_base_inline_notice_module_noticeWrapper--3354a",
  "actions": "bp_base_inline_notice_module_actions--3354a",
  "backgroundYellow": "bp_base_inline_notice_module_backgroundYellow--3354a",
  "backgroundBlue": "bp_base_inline_notice_module_backgroundBlue--3354a",
  "backgroundRed": "bp_base_inline_notice_module_backgroundRed--3354a",
  "backgroundGreen": "bp_base_inline_notice_module_backgroundGreen--3354a",
  "backgroundPurple": "bp_base_inline_notice_module_backgroundPurple--3354a",
  "actionButtonTertiary": "bp_base_inline_notice_module_actionButtonTertiary--3354a",
  "actionButtonPrimary": "bp_base_inline_notice_module_actionButtonPrimary--3354a",
  "contentContainer": "bp_base_inline_notice_module_contentContainer--3354a",
  "content": "bp_base_inline_notice_module_content--3354a",
  "title": "bp_base_inline_notice_module_title--3354a"
};
export { styles as default };